import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, throwError } from 'rxjs';
import { UserInfo } from '../models/user-info.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient) {
      this.setRefreshTokenToSessionStorage();
      this.setAuthStatusToSessionStorage();
      this.setDSFDetailsCookieToSessionStorage();
  }

  get userInfo(): UserInfo | null {

    let userInfo: UserInfo | null = null;
    let DSFDetails = this.getDSFDetailsFromSessionStorage();
    if (DSFDetails) {
      userInfo = JSON.parse(DSFDetails);
      return userInfo;
    }
    return null;
  }

  get isLoggedIn(): boolean {
    let authStatus = this.getAuthStatusFromSessionStorage();
    if (authStatus) {
      return (new Date(+authStatus) > new Date());
    }
    return false;
  }

  refreshToken(): Observable<Object> {

    var refreshToken: string | null = this.getRefreshTokenFromSessionStorage();
    var refreshData = {
      Token: refreshToken
    }
    return this.http.post('/api/oidc/refresh', refreshData); //if refreshtoken is null, post will return 401 and be handled by interceptor and redirected to login
  }

  login(returnUrl: string): void {
    this.router.navigate(['access', 'login'], { queryParams: { returnUrl: returnUrl} })
  }

  logout(): void {
    window.location.href = "/api/oidc/logout";
  }

  private getRefreshTokenFromSessionStorage(): string | null {
    return sessionStorage.getItem('refresh');
  }
  private getAuthStatusFromSessionStorage(): string | null {
    return sessionStorage.getItem('authStatus');
  }
  private getDSFDetailsFromSessionStorage(): string | null {
    return sessionStorage.getItem('DSFDetails');
  }

  public setRefreshTokenToSessionStorage(): void {
    this.setCookieToSessionStorage('refresh');
  }
  private setAuthStatusToSessionStorage(): void {
    this.setCookieToSessionStorage('authStatus');
  }
  private setDSFDetailsCookieToSessionStorage(): void {
    this.setCookieToSessionStorage('DSFDetails');
  }
  private setCookieToSessionStorage(name: string): void {
    let cookie = this.cookieService.get(name);
    if (cookie) {
      sessionStorage.setItem(name, cookie);
      this.cookieService.delete(name, '/'); //, window.location.host, true, 'Strict');
    }
  }

  public removeAuthValuesFromSessionStorage(): void {
    sessionStorage.removeItem('refresh');
    sessionStorage.removeItem('authStatus');
    sessionStorage.removeItem('DSFDetails');
  }

  private logAuthInfo(message: string): void {
    const d = new Date();
    console.log(`${d.toLocaleTimeString()} ${message}`);
  }

}
